import createConverter from './lib/create_converter';
import Topic from 'models/topic';

export default createConverter(Topic);



// WEBPACK FOOTER //
// ./src/scripts/application/dto_converters/topic_converter.js